













import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Modal extends Vue {
  name: "Modal";

  @Prop({ required: true })
  private modalId!: string;

  @Prop({ default: "" })
  private size: string;
}
